const features = [
    {
        icon: 'RunIcon',
        title: 'Optimzed',
        description: 'Ensuring websites are optimized for the fastest User Experience.'
    },
    {
        icon: 'MobileFriendlyIcon',
        title: 'Responsive',
        description: 'Creating layouts that works on all devices.'
    },
    {
        icon: 'SatisfiedIcon',
        title: 'Intuitive',
        description: 'The application with the best UI are the ones that don\'t need a tutorial.'
    },
    {
        icon: 'CafeIcon',
        title: 'Maintainable',
        description: 'Writing maintainable code for better performance and collaboration experiences.'
    }
]

export default features